import React, { useEffect, useState, useRef, useCallback } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";

import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { validateInputText } from "../../../utilities/ValidateUtil";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { DialogOpenReport } from "../../../components/DialogService/DialogService";

//SERVICE
import { pRequestSummaryReport } from "../../../service/200/P210Service";
import { genReportDurationList } from "../../../service/GEN/GenService";

//Report
import { pdfRPT210 } from "../../../Report/210/RPT210PDF";
import { wordRPT210 } from "../../../Report/210/RPT210Word";
import { RPT210Excel } from "../../../Report/210/RPT210Excel";

// List
import P210List from "./P210List";

export default function P207() {
    const toast = useRef(null);
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    // DATA
    const [errData, setErrData] = useState(null);
    const [dataForm, setDataForm] = useState({
        contractNo: "",
        reportDate: "",
        reportType: "W",
        routeNo: 1,
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    // SEARCH
    const [searchData, setSearchData] = useState({
        contractNo: "",
        routeNo: 0,
        userId: dataUserSession() ? dataUserSession().userId : "",
        ...(history.location.state ? history.location.state : ""),
    });

    // DropDown
    const [reportDurationItem, setsReportDurationItem] = useState({ data: [], data2: [] });
    const [rdo, setRdo] = useState("W");

    // Report
    const [dialogPDF, setDialogPDF] = useState(false);
    const [dataReport, setDataReport] = useState([]);

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state) {
                setSearchData({ ...searchData, ...history.location.state });
            } else {
                // setSearchData({ ...searchData, contractNo: "ป.16-1/64", routeNo: 1 });
                history.push("/208");
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onGetgenReportDurationList();
    }, [searchData]);

    useEffect(() => {
        handlerFilterReportDuration(rdo);
    }, [rdo]);

    const onGetgenReportDurationList = () => {
        genReportDurationList(searchData).then(
            (res) => {
                setLoading(false);
                const _filter = res.filter((item) => {
                    return item.reportType === rdo;
                });
                setsReportDurationItem({ ...reportDurationItem, data: res, data2: _filter });
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const validation = (object) => {
        if (object.reportType === "" || object.reportDate === "") {
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };
    const submitForm = () => {
        if (validation(dataForm)) {
            const req = {
                // contractNo: "ป.16-1/64",
                // reportDate: "W%20210204-20211207",
                // reportType: "W",
                // routeNo: 1,
                // userId: "s16",
                contractNo: searchData.contractNo,
                reportDate: dataForm.reportDate,
                reportType: rdo,
                routeNo: dataForm.routeNo,
                userId: searchData.userId,
            };


            pRequestSummaryReport(req).then(
                (res) => {
                    // console.log(res);
                    setLoading(false);
                    setDataReport(res);
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const setValViewForm = (_key) => {
        if (dataForm !== null) return dataForm[_key];
    };

    const handlerSetDataFormSubmit = (key, value) => {
        setDataForm({ ...dataForm, [key]: value });
    };

    const handlerGetViewReport = (name) => {
        if (dataReport.length > 0) {
            return dataReport[0][name];
        }
    };

    const handlerFilterReportDuration = useCallback(
        (sts) => {
            const _filter = reportDurationItem.data.filter((item) => {
                return item.reportType === sts;
            });
            setsReportDurationItem({ ...reportDurationItem, data2: _filter });
        },
        [reportDurationItem, rdo]
    );

    const onExport = (act) => {
        if (dataReport.length > 0) {
            switch (act) {
                case "PDF":
                    pdfRPT210(dataReport, setLoading, setDialogPDF);
                    break;
                case "WORD":
                    wordRPT210(dataReport, showMessages, setLoading);
                    break;
                case "EXCEL":
                    RPT210Excel(dataReport, showMessages, setLoading);
                    break;
                default:
                    break;
            }
        } else {
            showMessages("error", "ผิดพลาด", "กรุณาค้นหาข้อมูล");
        }
    };

    const handlerReport = () => {
        submitForm();
    };
    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">รายงานสรุปผลการก่อสร้างรายสัปดาห์/รายเดือน</h2>
                        <hr /> */}
                        <div className="p-fluid p-grid">
                            <div className="p-field p-cow-12 p-md-1">
                                <label htmlFor="">ประเภท</label> <span style={{ color: "red" }}>*</span>
                                <div className="p-field-radiobutton">
                                    <RadioButton
                                        inputId="reportType"
                                        name="reportType"
                                        value="W"
                                        onChange={(e) => {
                                            setRdo(e.value);
                                        }}
                                        checked={rdo === "W"}
                                    />
                                    <label htmlFor="reportType">รายสัปดาห์</label>
                                </div>
                                {submitted && !dataForm.reportType && validateInputText("reportType", "ประเภท")}
                            </div>
                            <div className="p-field p-cow-12 p-md-3">
                                <label htmlFor=""></label>
                                <div className="p-field-radiobutton" style={{ marginTop: 6 }}>
                                    <RadioButton
                                        inputId="reportType"
                                        name="reportType"
                                        value="M"
                                        onChange={(e) => {
                                            setRdo(e.value);
                                        }}
                                        checked={rdo === "M"}
                                    />
                                    <label htmlFor="reportType">รายเดือน</label>
                                </div>
                            </div>
                        </div>
                        <div className="p-fluid  p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="reportDate">{rdo === "W" ? "รายสัปดาห์" : "รายเดือน"} </label> <span style={{ color: "red" }}>*</span>
                                <Dropdown
                                    className="p-invalid"
                                    id="reportDate"
                                    value={setValViewForm("reportDate")}
                                    placeholder="เลือก รายสัปดาห์"
                                    options={reportDurationItem.data2}
                                    optionLabel="reportDateDesc"
                                    optionValue="reportDateCode"
                                    onChange={(e) => handlerSetDataFormSubmit("reportDate", e.target.value)}
                                />
                                {submitted && !dataForm.reportDate && validateInputText("reportDate", "รายสัปดาห์")}
                            </div>

                            <div className="p-field p-col-12 p-md-4">
                                <div style={{ display: "flex", marginTop: '4px' }}>
                                    <Button className="p-button-primary p-button btn-srh-responsive" icon="pi pi-search" label="ค้นหา" onClick={() => handlerReport()} />
                                    <Button
                                        className="p-button-secondary p-button btn-srh-responsive"
                                        icon="pi pi-arrow-left"
                                        label="กลับหน้าจอหลัก"
                                        style={{ marginLeft: "5px" }}
                                        onClick={() => history.push("/208")}
                                    />
                                </div>
                            </div>
                        </div>
                        {dataReport.length > 0 && (
                            <>
                                <hr />
                                <div className="p-fluid p-grid">
                                    <div className="p-field p-cow-12 p-md-12">
                                        <Button tooltip="PDF" className="p-button-danger p-button p-mr-2 p-mb-2" icon="fa fa-file-pdf" label="PDF" style={{ width: 100 }} onClick={() => onExport("PDF")} />
                                        <Button tooltip="Word" className="p-button-info p-button p-mr-2 p-mb-2" icon="fa fa-file-word" label="Word" style={{ width: 100, marginLeft: "5px" }} onClick={() => onExport("WORD")} />
                                        <Button tooltip="Excel" className="p-button-success p-button p-mr-2 p-mb-2" icon="fa fa-file-excel" label="Excel" style={{ width: 100, marginLeft: "5px" }} onClick={() => onExport("EXCEL")} />
                                    </div>
                                </div>
                                <div className="p-fluid p-grid">
                                    <div className="p-field p-cow-12 p-md-4">
                                        <label htmlFor="">เลขที่สัญญา</label>
                                        <InputText disabled={true} placeholder="เลขที่สัญญา" value={searchData.contractNo} />
                                    </div>
                                    <div className="p-field p-cow-12 p-md-4">
                                        <label htmlFor="">ผู้คุมงาน</label>
                                        <InputText disabled={true} placeholder="ผู้คุมงาน" value={handlerGetViewReport("supervisorName")} />
                                    </div>
                                    <div className="p-field p-cow-12 p-md-4">
                                        <label htmlFor="">บริษัทผู้รับจ้าง</label>
                                        <InputText disabled={true} placeholder="บริษัทผู้รับจ้าง" value={searchData.contractorName} />
                                    </div>
                                </div>

                                <div className="p-fluid p-grid">
                                    <div className="p-field p-cow-12 p-md-12">
                                        <P210List dataTable={dataReport} />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <DialogOpenReport header="พิมพ์รายงานการประเมิน" dialog={dialogPDF} setDialog={setDialogPDF} />
        </>
    );
}
